import { NIL_OR_NAN_DEFAULT_PLACEHOLDER } from 'app/pages/loanApplication/Validation/restyled/LoanInfoModal/LoanInfoModal.constant';
import _ from 'lodash';

import { CompensationType } from 'constants/loanApplication';

// A deny criterion carries a short name and a prose reason, and either can be absent: house guidance
// requires a reason on every deny node, but nothing enforces it. Splitting the two lets the cell render
// "Name: reason", just the name, or just the reason, rather than stranding a bare "Name: -" (DEV-6519).
export const getDenialReasonParts = ({ criteriaName, denialReason } = {}) => ({
  label: criteriaName ? `${criteriaName}${denialReason ? ': ' : ''}` : '',
  text: denialReason || (criteriaName ? '' : NIL_OR_NAN_DEFAULT_PLACEHOLDER),
});

// The compensation the price actually carries, mirroring the pricing engine's own rule
// (Skynet.Pricing LenderLoanOptionFactory.ResolvePriceCompensation, which is the source of truth):
// only lender-paid comp is funded out of the price and nets out of Final Price after Comp, so only it
// belongs in this column. Borrower-paid comp is collected from the borrower in fees and deducts nothing.
// Anything else — no comp plan (retail), or a plan whose per-loan disposition is still unresolved — is
// unknown rather than zero, and renders as the nil placeholder instead of a confident 0.
export const getPriceCompensationPoints = loanOption => {
  const points = _.get(loanOption, 'compensationPoints');
  const compensationType = _.get(loanOption, 'compensationType');

  if (_.isNil(points)) {
    return null;
  }

  if (compensationType === CompensationType.LENDER_PAID) {
    return points;
  }

  return compensationType === CompensationType.BORROWER_PAID ? 0 : null;
};
